import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#52B61B",
        secondary: "#52B61B",
        accent: "#F08300",
        info: "#F08300",
        error: "#CB3234",
        success: "#30B700"
      },
      dark: true,
    },
  },
});
